const shareEvents = new EventDelegator([{
    selector: '#js-app',
    eventType: 'click',
    events:
        {
            share: (e, d) =>
            {
                share();
            },
            enableshare: (e, d) =>
            {
                enableShare();
            },
            showshare: (e, d) =>
            {
                showshare(true, true, d.showshare);
            },
            closeshare: (e, d) =>
            {
                showshare(false, (d.closeshare === 'true'));
            }
        }
}]);


function enableShare()
{
    $('[data-share], #share-on__title').removeClass('share-on__title--error share-on__btn--disabled');
}

function showshare(show, toggleCheckout, platform)
{
    const share = $('#share');
    const body = $('body');
    show ? share.fadeIn() : share.fadeOut();
    show ? body.addClass('no-scroll') : body.removeClass('no-scroll');
    $("[data-enableshare='twitter'], [data-enableshare='facebook']").attr('checked', false);
    $('[data-share]').addClass('share-on__btn--disabled');
    if (platform)
    {
        enableShare();
        (platform === 'twitter') ? $("[data-enableshare='twitter']").attr('checked', true) : $("[data-enableshare='facebook']").attr('checked', true);
    }
    toggleCheckout ? displayCheckout(!show) : false;
}

function share()
{
    const value = $("input[name='share-on']:checked").val();

    if (value)
    {
        const amount = (checkoutTotal < 100) ? 'loads' : '%24' + checkoutTotal;
        let url;
        url = (value === 'twitter') ?
            `https://twitter.com/intent/tweet?url=https%3A%2F%2Fthebestvpn.com%2Finternet-2029%2Findex.html&text=According%20to%20https%3A%2F%2Fthebestvpn.com%20I%20could%20be%20spending%20${amount}%20on%20just%20browsing%20the%20web%20if%20net%20neutrality%20is%20not%20protected!%20Check%20out%20their%20interactive%20dystopian%20internet%20in%202029%20simulator%20here%3A%20`
            :
            'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fthebestvpn.com%2Finternet-2029%2Findex.html';
        window.open(url, '_blank');
    }
    else
    {
        $('#share-on__title').addClass('flash share-on__title--error');
        $('#share-on__options label').addClass('tada');

        setTimeout(function ()
        {
            $('#share-on__title, #share-on__options label').removeClass('flash tada');
        }, 1100);
    }
}